/*
 * Further: "New Arrivals" product strip.
 *
 * Ported from the inline script of the static site's index.html
 * (fetchShopifyProducts). Loaded by sections/further-new-arrivals.liquid.
 *
 * Automatic mode reads the storefront's own /products.json feed, exactly like
 * the static site did (it just no longer has to cross domains): newest
 * products first, sold-out products skipped. In collection mode the cards are
 * already in the page (rendered by Liquid) and only the motion is added.
 */
(function () {
  'use strict';

  if (window.FurtherNewArrivals) return;
  window.FurtherNewArrivals = true;

  var IMAGE_WIDTHS = [360, 540, 720, 1080];
  var IMAGE_SIZES = '(max-width: 600px) 75vw, 25vw';

  /* Visitors who ask their device for less motion get a still strip (it can
     still be scrolled by hand) and no tilt. */
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* The lowest price of the product, formatted the way the shop shows it
     ("$1,250.00"). */
  function priceOf(product) {
    var lowest = null;
    (product.variants || []).forEach(function (v) {
      var n = parseFloat(v.price);
      if (!isNaN(n) && (lowest === null || n < lowest)) lowest = n;
    });
    if (lowest === null) return '';
    return '$' + lowest.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* Shopify's image CDN resizes on request: ask for a card-sized picture
     instead of the multi-megabyte original. */
  function sized(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildCard(product, productsBase) {
    var first = product.images && product.images[0] ? product.images[0] : null;
    var image = first ? first.src : '';
    if (!image) return null;
    var price = priceOf(product);
    var url = productsBase + product.handle;

    var link = document.createElement('a');
    link.className = 'strip-item';
    link.href = url;

    var card = document.createElement('div');
    card.className = 'strip-item-card';

    var imageWrap = document.createElement('div');
    imageWrap.className = 'strip-item-image';
    var imgEl = document.createElement('img');
    var widths = IMAGE_WIDTHS.filter(function (w) {
      return !first.width || w <= first.width;
    });
    if (widths.length) {
      imgEl.sizes = IMAGE_SIZES;
      imgEl.srcset = widths
        .map(function (w) {
          return sized(image, w) + ' ' + w + 'w';
        })
        .join(', ');
      imgEl.src = sized(image, widths[widths.length - 1]);
    } else {
      imgEl.src = image;
    }
    imgEl.alt = '';
    imgEl.loading = 'lazy';
    imageWrap.appendChild(imgEl);
    card.appendChild(imageWrap);

    var info = document.createElement('div');
    info.className = 'strip-item-info';
    var title = document.createElement('div');
    title.className = 'strip-item-title';
    title.textContent = product.title;
    info.appendChild(title);
    if (price) {
      var priceEl = document.createElement('div');
      priceEl.className = 'strip-item-price';
      priceEl.textContent = price;
      info.appendChild(priceEl);
    }
    card.appendChild(info);

    link.appendChild(card);
    return link;
  }

  function startStrip(strip) {
    if (!strip.children.length) return;

    // Duplicate items for seamless loop. The copies are only for the eye:
    // screen readers and the Tab key skip them.
    var items = Array.from(strip.children);
    items.forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      strip.appendChild(copy);
    });

    // Slow continuous autoscroll with seamless loop
    var speed = 0.5;
    var paused = false;
    var halfWidth = 0;

    function measureHalf() {
      halfWidth = strip.scrollWidth / 2;
    }
    measureHalf();

    // The cards change width with the window (a phone turned sideways):
    // measure the loop again so it stays seamless.
    function onResize() {
      if (!strip.isConnected) {
        window.removeEventListener('resize', onResize);
        return;
      }
      measureHalf();
      if (halfWidth > 0 && strip.scrollLeft >= halfWidth) strip.scrollLeft -= halfWidth;
    }
    window.addEventListener('resize', onResize);

    if (reduceMotion) return;

    function autoScroll() {
      if (!strip.isConnected) return; // section was re-rendered or removed in the theme editor
      if (!paused) {
        strip.scrollLeft += speed;
        if (strip.scrollLeft >= halfWidth) {
          strip.scrollLeft -= halfWidth;
        }
      }
      requestAnimationFrame(autoScroll);
    }
    requestAnimationFrame(autoScroll);

    // Pause on hover and touch
    strip.addEventListener('mouseenter', function () {
      paused = true;
    });
    strip.addEventListener('mouseleave', function () {
      paused = false;
    });
    strip.addEventListener(
      'touchstart',
      function () {
        paused = true;
      },
      { passive: true }
    );
    strip.addEventListener('touchend', function () {
      paused = false;
    });
    strip.addEventListener('touchcancel', function () {
      paused = false;
    });

    // Keyboard: the strip holds still while a card has the focus
    strip.addEventListener('focusin', function () {
      paused = true;
    });
    strip.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !strip.contains(e.relatedTarget)) paused = strip.matches(':hover');
    });

    // 3D tilt effect on hover for product cards
    strip.querySelectorAll('.strip-item').forEach(function (item) {
      var card = item.querySelector('.strip-item-card');
      if (!card) return;

      item.addEventListener('mousemove', function (e) {
        var rect = item.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateY = ((x - centerX) / centerX) * 2;
        var rotateX = ((centerY - y) / centerY) * 2;
        card.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-1px)';
      });

      item.addEventListener('mouseleave', function () {
        card.style.transform = 'rotateX(0deg) rotateY(0deg) translateY(0px)';
      });
    });
  }

  function initStrip(strip) {
    if (!strip || strip.getAttribute('data-further-strip') === 'ready') return;
    strip.setAttribute('data-further-strip', 'ready');

    if (strip.getAttribute('data-source') === 'collection') {
      startStrip(strip);
      return;
    }

    var feedUrl = strip.getAttribute('data-feed-url') || '/products.json?limit=50&sort_by=created-descending';
    var productsBase = strip.getAttribute('data-products-base') || '/products/';
    var limit = parseInt(strip.getAttribute('data-limit'), 10) || 13;

    fetch(feedUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var products = (data.products || []).filter(function (product) {
          // Skip sold out products (all variants unavailable)
          var variants = product.variants || [];
          return (
            variants.length === 0 ||
            variants.some(function (v) {
              return v.available;
            })
          );
        });

        products.slice(0, limit).forEach(function (product) {
          var card = buildCard(product, productsBase);
          if (card) strip.appendChild(card);
        });

        startStrip(strip);
      })
      .catch(function (err) {
        console.error('Failed to fetch products:', err);
      });
  }

  function initAll(root) {
    var strips = (root || document).querySelectorAll('[data-further-strip]');
    for (var i = 0; i < strips.length; i++) {
      initStrip(strips[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: the section was added or re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
